import React, { useEffect, useRef, useState } from 'react'
import { Option, Select } from '@mui/joy';
import { serviceContent } from "../data/serviceContent";

const serviceArr = Object.keys(serviceContent).map(key => serviceContent[key]?.card?.servicetitle);

function ContactForm() {

    const [formData,setformData] = useState({name : "",email : "",number : "",city : "",services : "",message : "",});
    const [nameError,  setnameError] = useState(null); 
    const [emailError, setemailError] =  useState(null);
    const [numberError, setnumberError] =  useState(null);
    const [cityError, setcityError] =  useState(null);    
    const [servicesError, setservicesError] =  useState("");
    const [messageError, setmessageError] =  useState(null);
    const [emailValidate, setemailValidate] =  useState(null);
    const [formValid, setformValid] =  useState(false);
    
    useEffect(()=>{
        formIsValidate()
    },[formData,formValid,nameError,emailError,numberError,cityError,servicesError,messageError,emailValidate,formValid,])
    
    function validateEmail(email){
        const validEmail = email.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
        if(!formData.email.trim() == "" && !validEmail){setemailValidate(true);}
        else{setemailValidate(false);}
      };

      function formIsValidate(){

        if(!formData.name === "" && !formData.number === "" && !formData.city === "" && !formData.services === "" && !formData.message === "" && !emailValidate === true)
        {
            setformValid(true)
        }else{
            setformValid(false)
        }
      }

    function formSubmit(e){
       e.preventDefault();

        setformData({...formData ,name : formData.name.trim(),email : formData.email.trim(),number : formData.number.trim(),city : formData.city.trim(),services : formData.services.trim(),message : formData.message.trim(),})

        if(formData.message.trim() === ""){setmessageError(true)}
        else{setmessageError(false);};
        if(formData.email.trim() === ""){setemailError(true)}
        else{setemailError(false);setemailValidate(false)};validateEmail(formData.email);
        if(formData.number.trim() === ""){setnumberError(true)}
        else{setnumberError(false);};
        if(formData.city.trim() === ""){setcityError(true)}
        else{setcityError(false);};
        if(formData.services.trim() === ""){setservicesError(true)}
        else{setservicesError(false);};
        if(formData.name.trim() === ""){setnameError(true)}
        else{setnameError(false);};

    }

  return (
    <>
            <form className="lqd-cf-form init contact-form" noValidate data-status="init">
                <div className="row -mx-15">
                    <div className="col-md-6 px-15 animation-element lqd-unit-animation-done">
                    <span className="lqd-form-control-wrap name">
                        <input type="text" name="name" size="40" value={formData.name} onChange={(e)=>{setformData({...formData , name : e.target.value});setnameError(false);formIsValidate();}} className="lqd-cf-form-control text-17 leading-1/7em text-gray-700 " placeholder="Name"/>
                        <div className={`border-bottom ${nameError ? 'border-b-red' : ''}`}/>
                    </span>
                    <span className="lqd-form-control-wrap">
                        <input type="email" name="email" size="40" value={formData.email} onChange={(e)=>{setformData({...formData , email : e.target.value});setemailError(false); validateEmail(formData.email);formIsValidate();}} className="lqd-cf-form-control text-17 leading-1/7em text-gray-700 border-black-20" placeholder="Email"/>
                        <div className={`border-bottom ${emailError ? 'border-b-red' : ''}`}/>
                        {
                            emailValidate? <p className='accept-files clr-red'>Please enter a valid email address...</p> : ""
                        }
                    </span>
                    <span className="lqd-form-control-wrap">
                        <input type="number" name="number" size="40" value={formData.number} onChange={(e)=>{setformData({...formData , number : e.target.value});setnumberError(false);formIsValidate();}} className="lqd-cf-form-control text-17 leading-1/7em text-gray-700 border-black-20" placeholder="Number"/>
                        <div className={`border-bottom ${numberError ? 'border-b-red' : ''}`}/>
                    </span>
                    <span className="lqd-form-control-wrap">
                        <input type="text" name="city" placeholder="City" size="40" value={formData.city} onChange={(e)=>{setformData({...formData , city : e.target.value});setcityError(false);formIsValidate();}} className="lqd-cf-form-control text-17 leading-1/7em text-gray-700 border-black-20"/>
                        <div className={`border-bottom ${cityError ? 'border-b-red' : ''}`}/>
                    </span>
                    </div>
                    <div className="col-md-6 px-15 animation-element lqd-unit-animation-done">
                    <Select
                        onChange={(e,val)=>{setformData({...formData , services : val});setservicesError(false);formIsValidate();}}
                        placeholder="Choose one…"
                        className='select-box'
                        sx={{marginTop:"3px",borderRadius:"0",fontSize:"18px",color:"#000 !important",padding:"5px 0 5px 0", backgroundColor:"#fff",'&:hover': {backgroundColor : "#fff"}}}
                        variant="plain"
                    >
                        {
                            serviceArr?.map((data,ind)=>{
                                return(
                                    <Option value={data.replace(/-/g,' ')}>{data.replace(/-/g,' ')}</Option>
                                )
                            })
                        }
                    </Select>
                        <div  className={`border-bottom ${servicesError ? 'border-b-red' : ''}`} />
                    <span className="lqd-form-control-wrap message" style={{paddingTop:"10px"}}>
                        <textarea name="message" cols="10" rows="6" onChange={(e)=>{setformData({...formData , message : e.target.value});setmessageError(false);formIsValidate();}} className="lqd-cf-form-control text-17 leading-1/7em text-gray-700 border-black-20" placeholder="Message" ></textarea>
                        <div  className={`border-bottom ${messageError ? 'border-b-red' : ''}`} />
                    </span>
                    </div>
                    <div className="col-md-6 mt-1/5rem px-15 animation-element lqd-unit-animation-done">
                        <p>By clicking Send a message button, you agree to use our “Form” terms And consent cookie usage in browser.</p>
                    </div>
                    <div className="col-md-6 mt-1/5rem text-md-right px-15 animation-element lqd-unit-animation-done input-filled">
                        <input onClick={formSubmit} type="submit" value="Send a message" className={`${!formValid ? "contact-form-btn" : ""} lqd-cf-form-control has-spinner bg-primary border-0 text-14 font-bold tracking-0/5 uppercase text-white`}/>
                    </div>
                </div>
                <div className="lqd-cf-response-output" aria-hidden="true"></div>
                </form> 
    </>
  )
}

export default ContactForm;